/** PUT body for sadarat-only Edit-in-Dialog (male and/or female slots). */
export function toSadaratPartialUpdate(data: Record<string, unknown>): {
  sadaratMaleId?: unknown;
  sadaratFemaleId?: unknown;
} {
  const out: { sadaratMaleId?: unknown; sadaratFemaleId?: unknown } = {};
  if ("sadaratMaleId" in data) {
    out.sadaratMaleId = data.sadaratMaleId || null;
  }
  if ("sadaratFemaleId" in data) {
    out.sadaratFemaleId = data.sadaratFemaleId || null;
  }
  // Legacy single-slot forms still send sadaratId — map to male.
  if (!("sadaratMaleId" in data) && !("sadaratFemaleId" in data) && "sadaratId" in data) {
    out.sadaratMaleId = data.sadaratId || null;
  }
  return out;
}
